import React, { useEffect, useState } from "react";
import {
  addrouteAndRateAPI,
  getAllCountryList,
  getManagerRatePriceList,
  getRouteList,
  getRouteWiseCountryList,
  retrieveRouteAndRateList,
} from "../../api/api";
import { token, type, userid } from "../../component/common/AdminAuth";
import { numberOnly } from "../Utils/Helper";

function AddRouteRatePopup(props) {
  const [countryList, setCountryList] = useState();
  const [route, setRoute] = useState();
  const [managerPriceList, setManagerPriceList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, seterror] = useState({
    errarStatus: false,
    errorMessage: "",
    bgcolor: "",
  });

  const [data, setData] = useState({
    price: "",
    country_code: "",
    route: "",
    status: "1",
    method: "add",
    buy_price: "",
    system_id: props.selectedSystemID,
    allow_route: props.allow_route,
    user_id: userid,
    token: token,
    type: type,
  });


  const isRestrictedManager =
    type === "Manager" && Number(data.allow_route) === 0;

  useEffect(() => {
    if (type === "Manager" && Number(props.allow_route) === 0) {
      getManagerRatePriceList(userid).then((res) => {
        if (res.data.success === true) {
          setManagerPriceList(res.data.data);
          const uniqueRoutes = [];
          const seenRouteIds = new Set();
          res.data.data.forEach((item) => {
            if (!seenRouteIds.has(item.route_id)) {
              seenRouteIds.add(item.route_id);
              uniqueRoutes.push({ id: item.route_id, title: item.route_name });
            }
          });
          setRoute(uniqueRoutes);
        }
      });
    } else {
      getRouteList().then((res) => {
        setRoute(res.data.data);
      });
    }
    setData((prev) => ({
      ...prev,
      system_id: props.selectedSystemID,
      allow_route: props.allow_route,
    }));
  }, [props.selectedSystemID, props.allow_route]);


  useEffect(() => {
    if (props.type === "edit" && props.id) {
      retrieveRouteAndRateList(props.id, props.selectedSystemID).then((res) => {
        console.log("res Update Data ", res.data);
        let Newdata = { ...data };
        Newdata.country_code = numberOnly(res.data.data[0].regex);
        Newdata.price = res.data.data[0].cost;
        Newdata.route = res.data.data[0].smsc_id;
        Newdata.method = "update";
        Newdata.id = props.id;
        Newdata.system_id = props.selectedSystemID;
        routeWiseCountryList(res.data.data[0].smsc_id);
        setData(Newdata);
      });
    }
  }, [props.id]);

  const addrouteAndRate = () => {
    setIsLoading(true);
    addrouteAndRateAPI(data).then((res) => {
      if (res.data.success === true) {
        seterror({
          errarStatus: true,
          errorMessage: res.data.message,
          bgcolor: "alert alert-success",
        });
        setTimeout(() => {
          window.location.href = `/admin/user/rate-route-list/${props.selectedSystemID}`;
        }, 1000);
      } else {
        seterror({
          errarStatus: true,
          errorMessage: res.data.message,
          bgcolor: "alert alert-danger",
        });
        setIsLoading(false);
      }
    });
  };

  const update = () => {
    setIsLoading(true);
    addrouteAndRateAPI(data).then((res) => {
      if (res.data.success === true) {
        seterror({
          errarStatus: true,
          errorMessage: res.data.message,
          bgcolor: "alert alert-success",
        });
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        seterror({
          errarStatus: true,
          errorMessage: res.data.message,
          bgcolor: "alert alert-danger",
        });
        setIsLoading(false);
      }
    });
  };

  const getCountryList = (id) => {
    getAllCountryList(id).then((res) => {
      setCountryList(res.data.data);
    });
  };

  const routeWiseCountryList = (id) => {
    getRouteWiseCountryList(id).then((res) => {
      setCountryList(res.data.data);
    });
  };

  const countryHandler = (e) => {
    var index = e.target.selectedIndex;
    var optionElement = e.target.childNodes[index];
    var buyingPrice = optionElement.getAttribute("data-id");
    var sellingPrice = optionElement.getAttribute("selling");
    setData({
      ...data,
      country_code: e.target.value,
      buy_price: buyingPrice,
      price: sellingPrice,
    });
  };

  return (
    <div
      className="modal fade"
      id="exampleModalCenter"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLongTitle">
              {props.type === "edit" ? "Update" : "Add"} Rate / Route for{" "}
              <span className="text-success">{props.selectedSystemID} </span>
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body row">
            <div className="col-md-12">
              {error.errarStatus ? (
                <div className={error.bgcolor} role="alert">
                  <strong>Alert!</strong> {error.errorMessage}
                  <button
                    type="button"
                    className="close"
                    data-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              ) : null}
            </div>

            <div className="form-group col-md-6">
              {route && (
                <select
                  value={data.route}
                  onChange={(e) => {
                    var index = e.target.selectedIndex;
                    var optionElement = e.target.childNodes[index];
                    var id = optionElement.getAttribute("data-id");
                    setData({
                      ...data,
                      route: e.target.value,
                    });
                    if (isRestrictedManager) {
                      setCountryList(
                        managerPriceList.filter(
                          (item) => String(item.route_id) === String(id)
                        )
                      );
                    } else {
                      getCountryList(id);
                    }
                  }}
                  className="form-select"
                >
                  <option>Select Route</option>
                  {route.map((items, i) => (
                    <option key={i} data-id={items.id} value={items.title}>
                      {items.title}
                    </option>
                  ))}
                </select>
              )}
            </div>

            <div className="form-group col-md-6">
              <select
                value={data.country_code}
                onChange={countryHandler}
                className="form-select"
              >
                <option>Select Country</option>
                {countryList &&
                  countryList.map((items, i) => (
                    <option
                      key={i}
                      data-id={items.buy_price}
                      selling={items.selling_price}
                      value={items.country_code}
                    >
                      {items.country_name} ( {items.country_code})
                    </option>
                  ))}
              </select>
            </div>

            {data.buy_price && (
              <div className="form-group d-flex align-items-center gap-5 col-md-12">
                <label className=" m-0">Buy Price</label>
                <input
                  placeholder="Enter price"
                  className="form-control"
                  disabled
                  value={data.buy_price}
                  type="number"
                />
              </div>
            )}

            <div className="form-group d-flex align-items-center col-md-12">
              <label className="w-25 m-0">Selling Price</label>
              <input
                placeholder="Enter price"
                className="form-control"
                defaultValue={data.price}
                type="number"
                onChange={(e) => {
                  setData({
                    ...data,
                    price: e.target.value,
                  });
                }}
              />
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            {isLoading ? (
              <button type="button" className="btn btn-primary">
                Loading.....
              </button>
            ) : (
              <>
                {props.type === "edit" ? (
                  <button
                    onClick={update}
                    type="button"
                    className="btn btn-primary"
                  >
                    Update
                  </button>
                ) : (
                  <button
                    onClick={addrouteAndRate}
                    type="button"
                    className="btn btn-primary"
                  >
                    Add
                  </button>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddRouteRatePopup;
